export const DATE_RANGE_PRESETS = {
  NONE: 'n/a',
  TODAY: 'today',
  LAST_SEVEN_DAYS: 'last_seven_days',
  LAST_THIRTY_DAYS: 'last_thirty_days',
  LAST_SIX_MONTHS: 'last_six_months',
  CUSTOM_RANGE: 'custom_range',
};

export const DATE_RANGE_PRESET_LABELS = {
  [DATE_RANGE_PRESETS.NONE]: 'N/A',
  [DATE_RANGE_PRESETS.TODAY]: 'Today',
  [DATE_RANGE_PRESETS.LAST_SEVEN_DAYS]: 'Last 7 days',
  [DATE_RANGE_PRESETS.LAST_THIRTY_DAYS]: 'Last 30 days',
  [DATE_RANGE_PRESETS.LAST_SIX_MONTHS]: 'Last 6 months',
  [DATE_RANGE_PRESETS.CUSTOM_RANGE]: 'Custom Range',
};
